export const apiRoutes = {
  catalog: '/catalogs',
  plant: '/plant',
  consignmentSetting: '/consignment-setting',
  businessSetting: '/business-setting',
  user: '/auth',
  businessUnit: '/business-unit',
  consignmentNote: '/consignment-note',
  consignmentFile: '/consignment-files/pdf',
}
